define( [ "./selector-sizzle" ], function() {} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/selector.js
// module id = 19
// module chunks = 0